const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

function headers() {
  return {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json",
  };
}

export interface AguardandoEntregaItem {
  id: number;
  orderId: number;
  displayId: number;
  pedidoIntegracaoId: number;
  unidadesProntas: number;
  unidadesTotal: number;
  prontoParaEntrega: boolean;
  dataInicio: string;
  dataFim: string | null;
  status?: string;
  descricao: string | null;
  /** Observações das pizzas (inclusive as inseridas no sistema) + do pedido. */
  observacao?: string | null;
  montador: {
    id: number;
    nome: string;
  };
  entregador?: {
    id: number;
    nome: string;
  } | null;
  pedidoIntegracao?: {
    customerName: string | null;
    orderType?: string | null;
    observation: string | null;
    internalObservation?: string | null;
    statusIntegracao?: string | null;
  } | null;
  entregaDataInicio?: string | null;
  tempos?: {
    aguardandoMontagemSeg: number | null;
    emMontagemSeg: number | null;
    emFornoSeg: number | null;
    aguardandoEntregaSeg: number | null;
    emEntregaSeg: number | null;
  };
}

export interface AguardandoEntregaListResponse {
  items: AguardandoEntregaItem[];
  total: number;
}

export const aguardandoEntregaService = {
  listar: async (
    lojaId?: number,
    displayId?: string,
    orderId?: string,
    status?: "pending" | "done",
    emEntrega?: boolean
  ): Promise<AguardandoEntregaListResponse> => {
    const params = new URLSearchParams();
    if (lojaId != null) params.set("lojaId", String(lojaId));
    if (displayId?.trim()) params.set("displayId", displayId.trim());
    if (orderId?.trim()) params.set("orderId", orderId.trim());
    if (status) params.set("status", status);
    if (emEntrega === true) params.set("emEntrega", "true");
    const query = params.toString() ? `?${params.toString()}` : "";
    const response = await fetch(`${API_URL}/aguardando-entrega${query}`, {
      headers: headers(),
    });
    if (!response.ok) throw new Error("Erro ao buscar aguardando entrega");
    return response.json();
  },

  confirmarSaida: async (
    displayIds: number[],
    lojaId?: number
  ): Promise<{ updated: number }> => {
    const response = await fetch(
      `${API_URL}/aguardando-entrega/confirmar-saida`,
      {
        method: "POST",
        headers: headers(),
        body: JSON.stringify({ displayIds, lojaId }),
      }
    );
    if (!response.ok) {
      let message = "Erro ao confirmar saída";
      try {
        const body = (await response.json()) as {
          message?: string | string[];
        };
        const m = body?.message;
        if (typeof m === "string") message = m;
        else if (Array.isArray(m) && m[0]) message = m[0];
      } catch {
        /* ignore */
      }
      throw new Error(message);
    }
    return response.json();
  },
};
